export default {
  Language: '中文',
  system: {
    homePage: {
      login: '登录',
      register: '注册',

    },
    headerMenu: {
      HomePage: "首页",
      ScientificData: "科学数据",
      PDSDataSet: "PDS卷集",
      WebGis: "WebGis",
      Moon: "月球",
      Mars: "火星",
      Planet: "行星",
      SampleMoon: "月球样品",
      SampleAsteroid: '小行星样品',
      LunarSample: "行星地名库",
      PopularScience: "科普教育",
      ResourceTools: "资源工具",
      AboutUs: "关于我们",
      PlanetaryDatabaseName: "行星地库名",
      extraterrestrial: "地外样品",
    },
    infoData: {
      lastNew: "最新动态",
      more: "更多",
      Roam: "月球",
      Lunar: "火星",
      MoonandPlanets: "全景漫游",
      PopularScience: "科普教育",

      RecentNews: "最新数据",
      DataRelease: "数据发布",
      TasksIntroduction: "任务介绍",
      OngoingNews: "动态新闻",
      LatestProduct: "最新成果",
      NoticeandAnnouncement: "通知公告",
      Other: "其他",
      ReleaseTime: "发布时间",
      PageViews: "浏览次数"
    },
    footData: {
      Name: "中国科学院国家天文台月球与深空探测科学应用中心",
      ContactUs: "联系我们",
      RecordNumber: "备案序号",
      WenbaoNetworkSecurityFilingNumber: "文保网安备案号"
    },

    PopularScience: {
      Moon: "月球",
      Mars: "火星",
      ViewCount: "访问量",
      AllCategories: "全部分类",
      DataIndex: "数据索引"
    },
    ResourceTools: {
      ResourceTools: "资源工具",
      ScienceProducts: "科普产品",
      ModelProducts: "模型产品",
      Books: "图书专著",
      NationalStandard: "国家标准"
    }
  },
  regist: {
    UserType: "用户类型",
    UserName: "用户账号",
    Email: "邮 箱",
    RealName: "真实姓名",
    Password: "设置密码",
    ConfirmPassword: "确认密码",
    VerificationCode: "验证码",
    Company: "单位",
    Telephone: "手机号码",
    Fax: "",
    DetailedAddress: "",
    Postcode: ""
  },
  ScientificData: {
    DataCatalog: "数据目录",
    ScientificDataTree: "科学数据目录树",
    MissionIntroduction: "任务介绍",
    ReturnHomePage: "返回首页",
    DataDeclaration: "数据说明",
    ReferenceAndAcknowledgement: "引用致谢",
    CopyrightNotice: "版权声明",
    CurrentPosition: "当前位置",
    HomePage: "首页",
    ScientificData: "科学数据",
    Mars: "行星",
    Moon: "月球",
    Tianwen: "天问一号",
    TaskModel: "任务型号",
    DataType: "数据类型",
    PublicData: "公共数据",
    ProtectedData: "保护数据",
    CarryingPlatform: "搭载平台",
    DataAcquisitionTime: "数据获取时间",
    FirstReleaseTime: "首次发布时间",
    LatestReleaseTime: "最新发布时间",
    DataStatus: "数据状态",
    PublicAccess: "公开获取",
    AuthorizedAccess: "授权获取",
    Others: "其他",
    DataServiceContactInformation: "数据服务联系方式",
    TotalReleaseBatches: "发布批次总计",
    DataVolume: "数据量",
    DataFormat: "数据格式",
    DataVersion: "数据版本",
    DataProducer: "数据生产者",
    DataAceess: {
      Payload: "有效载荷",
      DataLevel: "数据级别",
      AdvancedSearch: "高级检索",
      Longitude: "经度",
      Latitude: "纬度",
      DisplayonPlanetMap: "在行星图中显示",
      Reset: "重置",
      DataName: "数据名称",
      StartTime: "开始时间",
      EndTime: "结束时间",
      OrbitNumber: "轨道圈数",
      Search: "检索",
      ClearSearch: "收回检索",
      DataList: "数据列表",
      ExpandMore: "展开更多",
      ReceivingStation: "接收站",
      DetectionMission: "探测任务",
      Size: "大小",
      DataVersion: "数据版本",
      BatchDownload: "批量下载",
      BatchFavorite: "批量收藏",
      DownloadNow: "立即下载",
      CancelFavorites: "取消收藏",
      AddtoFavorites: "加入收藏夹",
      DataAcquisition: "数据获取",
      NoDataAvailable: "暂无数据",
      DataStatus: "数据状态"
    }
  },
  DetailMoon: {
    startDate: '数据开始日期',
    endDate: '数据终止日期',
    genDate: '数据产生日期',
    releaseTime: '最新发布时间',
    producer: '数据生产者',
    applyDownload: '申请下载',
    pendingReview: '待审核',
    doi: 'DOI'
  },
  Login: {
    UserName: "用户名",
    PassWord: "密码",
    CheckCode: "验证码",
    ForgottenPassword: "忘记密码",
    Login: "登录",
    Cancel: "取消",
    PleaseLogin: "请登录",
    NewUserRegistration: "新用户注册",
    ResetPassword: "重置密码",
    Submit: "提交",
    PleaseEnterYourPassword: "请输入密码",
    PleaseEnterUserAccount: "请输入用户账号"
  },
  Register: {
    title: '注册',
    userType: '用户类型',
    userTypeSci: '科学数据用户',
    userTypeSample: '样品用户',
    accountLabel: '用户账号',
    accountPlaceholder: '您的账户名和登录名',
    nameLabel: '真实姓名',
    namePlaceholder: '您的真实姓名',
    phoneLabel: '手机号码',
    phonePlaceholder: '请输入手机号码',
    emailLabel: '邮箱',
    emailPlaceholder: '请输入邮箱',
    companyLabel: '单位',
    companyPlaceholder: '请输入单位全称',
    idCardLabel: '身份证号',
    pwdLabel: '设置密码',
    pwdConfirmLabel: '确认密码',
    pwdConfirmTip: '密码6-16位，区分大小写',
    codeLabel: '验证码',
    codePlaceholder: '输入验证码',
    goLogin: '使用已有账号登录'
  },
  FileData: {
    ScientificData: "科学数据",
    Mars: "行星",
    FileName: "文件名称",
    FileSize: "文件大小",
    Action: "操作",
    ViewDetail: "查看详情",
    Download: "下载"
  }
};
